<template>
  <v-container fluid py-0>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-container fluid pt-0>
          <v-row align="center">
            <div>
              <h1 class="headline">Process Logs</h1>
            </div>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="$apollo.loading"
      item-key="id"
      class="elevation-1"
    >
      <template #[`item.actions`]="{ item }">
        <default-list-actions
          :item="item"
          @viewItem="onView(item)"
          :hideView="false"
          hideEdit
          hideRemove
        ></default-list-actions>
      </template>
      <template #[`item.createdAtDate`]="{ item }">
        {{ item.createdAtDate | formatDate }}
      </template>
    </v-data-table>
    <process-log-details-dialog
      v-model="selectedItem"
      :show="showProcessLogDetailsDialog"
      @close="showProcessLogDetailsDialog = false"
    ></process-log-details-dialog>
    <v-row v-if="debug">
      <v-col>
        <code>{{ processLogs }}</code>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../../helpers";
import DefaultListActions from "../../shared/DefaultListActions.vue";
import ProcessLogDetailsDialog from "./ProcessLogDetailsDialog.vue";

const PROCESS_LOGS_QUERY = gql`
  query allProcessLogs {
    processLogs {
      edges {
        node {
          id
          name
          createdAtDate
          createdAtTime
          status
          source
        }
      }
    }
  }
`;
export default {
  components: { DefaultListActions, ProcessLogDetailsDialog },
  name: "process-logs",

  data() {
    return {
      debug: false,
      headers: [
        { text: "Process", value: "name" },
        { text: "Status", value: "status" },
        { text: "Date", value: "createdAtDate" },
        { text: "Time", value: "createdAtTime" },
        { text: "Source", value: "source" },
        { text: "Actions", value: "actions" },
      ],
      showProcessLogDetailsDialog: false,
      selectedItem: null,
    };
  },

  computed: {
    items() {
      return this.processLogs && this.processLogs.edges
        ? this.processLogs.edges.map(removeGQLTypename)
        : [];
    },
  },

  methods: {
    onView(item) {
      this.selectedItem = { ...item };
      this.showProcessLogDetailsDialog = true;
    },
  },

  apollo: {
    processLogs: {
      query: PROCESS_LOGS_QUERY,
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/plugins/process-logs/ProcessLogs.vue